import { render } from "./SingularIntegrationSettings.vue?vue&type=template&id=0274b4e0"
import script from "./SingularIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./SingularIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__